import { getTrackingUUID } from 'src/dataLayer/localData/cookies';
import {
  BABBEL_APP_VERSION,
  ROLLBAR_ACCESS_TOKEN,
  ROLLBAR_API_URL,
  RUNTIME_ENVIRONMENT
} from 'src/dataLayer/env';
import { DeclaredReporterPayload, ErrorPayload, Status } from './types';


const pickStatus = ({ status }: Response): Status => ({ status });
const isErrorEvent = (error: ErrorPayload): error is ErrorEvent => error instanceof ErrorEvent;
const isError = (error: ErrorPayload): error is Error => error instanceof Error;

const declareReporter = (level: string) => (
  errorName: string,
  payload: Partial<DeclaredReporterPayload>): Promise<Status> => {
  const browserString = navigator.userAgent;
  const payloadCopy = { ...payload };
  if (payloadCopy.requestParams?.payload?.user?.password) {
    delete payloadCopy.requestParams.payload.user.password;
  }

  let errorPayload: ErrorPayload = {};
  // Stringifying the original error payload results in stripping away all useful info for both ErrorEvent and Error
  // instances, so we need to create a new object in both cases.
  if (payloadCopy.error) {
    if (isErrorEvent(payloadCopy.error)) {
      errorPayload = {
        error: payloadCopy.error?.error as unknown,
        message: payloadCopy.error?.message,
        lineno: payloadCopy.error.lineno,
        filename: payloadCopy.error.filename,
        type: payloadCopy.error.type
      } as ErrorEvent;
    } else if (isError(payloadCopy.error)) {
      errorPayload = {
        cause: payloadCopy.error.cause,
        message: payloadCopy.error.message,
        stack: payloadCopy.error.stack
      };
    }
  }

  const trackingUuid = errorName === 'cookies:babbeltrackinguuid:failed' ? undefined : getTrackingUUID();

  const updatedPayload = { ...payloadCopy, trackingUuid, errorPayload };

  return window.fetch(ROLLBAR_API_URL, {
    method: 'POST',
    body: JSON.stringify({
      access_token: ROLLBAR_ACCESS_TOKEN,
      data: {
        level,
        environment: RUNTIME_ENVIRONMENT,
        platform: 'browser',
        code_version: BABBEL_APP_VERSION,
        client: { javascript: { browser: browserString } },
        body: { message: { body: errorName, payload: updatedPayload } }
      }
    })
  }).then(pickStatus, pickStatus);
};

export const reportError = declareReporter('error');
export const reportWarning = declareReporter('warning');
